/* eslint-disable @typescript-eslint/no-explicit-any */
import MasterCard from '../../components/MasterCard';
import Announcements from '../../components/Announcements';
import RecentTransaction from '../../components/RecentTransaction';
import PaymentDue from '../../components/PaymentDueDetailsCard';
import {
  transactionRequest,
  useProductName,
  rewardsRequest,
  fetchOfferRequest,
  fetchOfferPrefSubmitRequest,
  fetchOfferPreferenceRequest,
  RootState,
  fetchPopupStatusRequest,
  updatePopupStatusRequest,
  displayBusinessNameRequest,
  contactInfoRequest,
  useSuppressBusinessName,
  renderDescriptionParagraphs,
} from '@rb-serve-app/core';
import Spinner from '../../components/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import { EventType, useAnalytics } from '../../ui/Analytics';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import OfferModal from '../Offers/OfferModal';
import {
  CardLimitIncOfferContent,
  SupplementaryCardOfferContent,
  CreditLimitLegalSection,
  BalanceTrfrOfferContent,
  ResiOfferContent,
  RegiLegalSection,
} from '../Offers/OfferContent';
import CommanModal from '../../components/CommanModal';
import { useNavigate } from 'react-router-dom';
import SuccessModel from '../../components/SuccessModel';
import InlineError from '../../components/ErrorComponents/InlineError';
import {
  InteractiveTutorial,
  useTutorial,
  TutorialStepData,
} from '../../components/InteractiveTutorial';
import {
  disableInAppMessageListener,
  initializeInAppMessageListener,
  logBrazeCustomEvent,
  maybeRequestBrazePushPermissionFromInAppMessage,
  requestBrazeDataFlush,
  resetInAppMessageListener,
  setInAppMessageHandler,
  startInAppMessageTimeout,
} from '../../config/braze';

const Home = (prop: any) => {
  const hasTriggeredViewedHomeRef = useRef(false);
  const lastViewedHomeUserRef = useRef<string | null>(null);
  const hasPopupRequestStartedRef = useRef(false);
  const { trackEvent } = useAnalytics();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { contentfulData, rewards, offer } = useSelector((state: any) => ({
    contentfulData: state.contentful?.contentfulData,
    rewards: state.rewards,
    offer: state.offer,
  }));

  console.log('offer', offer);
  useEffect(() => {
    if (
      offer?.offerPreference?.statusCode === '200' ||
      offer?.targetedOfferPrefSubmit?.updateResult === 'success'
    ) {
      localStorage.setItem('hasClickedOffer', 'true');
    }
  }, [offer?.offerPreference, offer?.targetedOfferPrefSubmit]);

  const { entries = {}, assets = {} } = contentfulData || {};
  const rb_offer = entries?.rb_offers;
  const [supplementaryCardoffer, setSupplementaryCardoffer] = useState(false);
  const [isRESIoffer, setRESIoffer] = useState(false);
  const [balanceTrfroffer, setBalanceTrfroffer] = useState(false);
  const [creditLimitIncOffer, setCreditLimitIncOffer] = useState(false);
  const [confirmatioModalOpen, setConfirmationModalOpen] = useState(false);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [previousOffer, setPreviousOffer] = useState<
    'supplementary' | 'creditLimit' | 'balanceTransfer' | 'resi' | null
  >(null);
  const [shouldShowModal, setShouldShowModal] = useState(true);
  const [isBtAccept, setIsBTAccept] = useState(false);
  const [isActivatePopup, setIsactivatePopup] = useState(false);
  const [isEstatementPopup, setIsEstatementPopup] = useState(false);
  const [isUnlockCardPopup, setIsUnlockCardPopup] = useState(false);
  const [isLinkPopup, setIsLinkPopup] = useState(false);
  const [showOfferModal, setShowOfferModal] = useState(false);

  const {
    loading: popupLoading,
    isWalletEnabled,
    isUserCanAddCard,
    NotRemindMeLater,
    status: popupStatus,
  } = useSelector((state: RootState) => state.popup);
  const { loading: eppLoading, eppDetails } = useSelector(
    (state: any) => state.epp
  );
  const isPopupRequestSettled =
    popupStatus != null || (hasPopupRequestStartedRef.current && !popupLoading);
  const isDashboardReady =
    isPopupRequestSettled &&
    Boolean(rewards) &&
    !offer?.loading &&
    !eppLoading &&
    !popupLoading;

  const {
    showActivateCardPopup = null,
    showStmtPrefPopup = null,
    showUnlockCardPopup = null,
    showLinkCardPopup = null,
  } = popupStatus || {};

  const anyofferVisible =
    supplementaryCardoffer ||
    creditLimitIncOffer ||
    balanceTrfroffer ||
    isRESIoffer;

  useEffect(() => {
    if (anyofferVisible) {
      setShowOfferModal(true);
      return;
    }
    if (!showOfferModal) {
      const isActivateCardRemindLater =
        localStorage.getItem('activateCard_remindLater') === 'true';
      const isEstatementRemindLater =
        localStorage.getItem('eStatementPref_remindLater') === 'true';
      const isEstatementDismiss =
        localStorage.getItem('eStatementPref_dismiss') === 'true';
      const isUnlockRemindLater =
        localStorage.getItem('unLockCardpopup_remindLater') === 'true';
      const isLinkPopupDismiss =
        localStorage.getItem('linkPopup_dismiss') === 'true';
      console.log(
        'test3',
        isEstatementRemindLater,
        isEstatementDismiss,
        showStmtPrefPopup
      );
      setIsactivatePopup(!isActivateCardRemindLater && showActivateCardPopup);
      setIsEstatementPopup(
        !isEstatementRemindLater && !isEstatementDismiss && showStmtPrefPopup
      );
      setIsUnlockCardPopup(!isUnlockRemindLater && showUnlockCardPopup);
      setIsLinkPopup(!isLinkPopupDismiss && showLinkCardPopup);
    }
  }, [anyofferVisible, showOfferModal, popupStatus]);

  //offer priority logic
  const activateCardRemindMe = localStorage.getItem('activateCard_remindLater');

  useEffect(() => {
    const hasDismissedOffer = localStorage.getItem('hasDismissedOffer');
    if (hasDismissedOffer === 'true') {
      setShouldShowModal(false);
      setShowOfferModal(false);
    }
  }, []);

  useEffect(() => {
    const getValidWebOffers = () => {
      if (!offer?.offers || offer.offers.length === 0) return [];

      // Get offer type flags from contentful
      const rbOffersFlag = entries?.rb_offers?.rbOffersFlag;
      const offerTypeFlags = rbOffersFlag?.OFFERTYPE || {};

      return offer.offers.filter((currentOffer: any) => {
        const offerAny = currentOffer as any; // Cast to any to access API properties not in interface

        // Check if it's a valid offer type first
        const hasValidType =
          currentOffer?.offerType &&
          ['SCO', 'CLI', 'BT', 'RESI'].includes(currentOffer.offerType);
        if (!hasValidType) return false;

        // Map offer types to their web-specific flags
        const webOfferTypeMap: { [key: string]: string } = {
          SCO: 'SCOWEB',
          CLI: 'CLIWEB',
          BT: 'BTWEB',
          RESI: 'RESIWEB',
        };

        const webOfferFlag = webOfferTypeMap[currentOffer.offerType];

        // Check if this offer type is enabled in contentful flags for web
        // If the web flag exists and is explicitly set to false, filter out the offer
        if (offerTypeFlags[webOfferFlag] === false) {
          console.log(
            `Web offer type ${currentOffer.offerType} (${webOfferFlag}) is disabled via contentful flag`
          );
          return false;
        }

        // Get offer status - check nested response objects based on offer type
        let isActive = false;
        let expiryDate = null;

        if (currentOffer.offerType === 'SCO' && offerAny?.scoResponse) {
          isActive = offerAny.scoResponse.offer_status === 'Active';
          expiryDate = offerAny.scoResponse.expiry_date;
        } else if (currentOffer.offerType === 'CLI' && offerAny?.cliResponse) {
          isActive = offerAny.cliResponse.offer_status === 'Active';
          expiryDate = offerAny.cliResponse.expiry_date;
        } else if (
          currentOffer.offerType === 'RESI' &&
          offerAny?.resiResponse
        ) {
          isActive = true;
          expiryDate = offerAny.resiResponse.expiry_date;
        } else if (
          currentOffer.offerType === 'BT' &&
          offerAny?.btoffersResponse
        ) {
          // BT offers have a different structure
          isActive = true; // BT offers are considered active if they exist in the response
          const availableOffer =
            offerAny.btoffersResponse?.availableOffers?.[0];
          expiryDate = availableOffer?.offerDetails?.endDate;
        }

        // Check if offer hasn't expired (expires at end of day in user's local timezone)
        const expiryDateObj = expiryDate
          ? new Date(expiryDate + 'T23:59:59.999')
          : null;
        const currentDate = new Date();
        const isNotExpired = expiryDateObj
          ? expiryDateObj >= currentDate
          : false;

        console.log(`Web offer validation for ${currentOffer.offerType}:`, {
          hasValidType,
          isActive,
          expiryDate,
          expiryDateObj: expiryDateObj?.toISOString(),
          currentDate: currentDate.toISOString(),
          isNotExpired,
          isEnabledInContentful: offerTypeFlags[webOfferFlag] !== false,
          webOfferFlag,
          finalResult:
            isActive &&
            isNotExpired &&
            hasValidType &&
            offerTypeFlags[webOfferFlag] !== false,
        });

        return (
          hasValidType &&
          isActive &&
          isNotExpired &&
          offerTypeFlags[webOfferFlag] !== false
        );
      });
    };

    const validOffers = getValidWebOffers();
    const offerType = validOffers?.[0]?.offerType;

    // Reset all offer states
    setSupplementaryCardoffer(false);
    setBalanceTrfroffer(false);
    setCreditLimitIncOffer(false);
    setShowOfferModal(false);
    setRESIoffer(false);

    if (!validOffers.length) {
      console.log('No valid web offers found after feature flag filtering');
      return;
    }

    if (offerType === 'SCO') {
      setSupplementaryCardoffer(true);
    } else if (offerType === 'CLI') {
      setCreditLimitIncOffer(true);
    } else if (offerType === 'BT') {
      setBalanceTrfroffer(true);
    } else if (offerType === 'RESI') {
      setRESIoffer(true);
    }
  }, [offer?.offers, entries?.rb_offers?.rbOffersFlag]);

  const {
    userCredentials = {},
    accountDetails = {},
    accountId,
    customerId,
    isAuthenticated,
    error: paymentErr = null,
  } = useSelector((state: any) => state.user || {});

  useEffect(() => {
    if (!isAuthenticated || !isDashboardReady || !customerId) {
      return;
    }

    const currentUserId = String(customerId);

    if (
      hasTriggeredViewedHomeRef.current &&
      lastViewedHomeUserRef.current === currentUserId
    ) {
      return;
    }

    setInAppMessageHandler((event, extras) => {
      const messageType =
        extras.messageType || extras.message_type || extras.campaign_type;

      console.log('[Braze][IAM]', event, messageType || 'unknown', extras);

      const pushPermissionRequested =
        maybeRequestBrazePushPermissionFromInAppMessage(event, extras);

      if (pushPermissionRequested) {
        logBrazeCustomEvent('push_permission_requested_from_iam', {
          messageType: messageType || 'unknown',
          lifecycleEvent: event,
        });
      }
    });

    initializeInAppMessageListener();

    startInAppMessageTimeout(10000);

    trackEvent(EventType.PAGE_VIEW, 'dashboard', globalThis.location.href);

    console.log('[Braze][IAM] triggering viewed_home for:', currentUserId);

    logBrazeCustomEvent('viewed_home');

    requestBrazeDataFlush();

    hasTriggeredViewedHomeRef.current = true;
    lastViewedHomeUserRef.current = currentUserId;

    return () => {
      disableInAppMessageListener();
      resetInAppMessageListener();
    };
  }, [customerId, isAuthenticated, isDashboardReady, trackEvent]);

  // Be defensive: `state.rewards` may be null in tests or during loading.
  // Use an empty object fallback so destructuring won't throw.
  const { error = null } = useSelector((state: any) => state.rewards || {});
  console.log('rb_offer', rb_offer);
  const { transactions = {}, error: transactionErr = null } = useSelector(
    (state: any) => state.transactions || {}
  );
  const { contactDetails } = useSelector((state: any) => state.contactInfo);
  const [postNotificationBanner, setPostNotificationBanner] = useState(false);
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const [showApiErrorBanner, setShowApiErrorBanner] = useState(false);

  // Determine if EPP is visible
  const isEppVisible = eppDetails?.installData?.installmentPlans?.length >= 1;

  // Tutorial configuration from Contentful - conditional based on EPP visibility and offers visibility
  const tutorialSteps: TutorialStepData[] = React.useMemo(() => {
    const contentfulSteps = entries?.rb_announcement?.interactiveTutorial || [];

    // Check if offers should be hidden
    const hideOffersWeb =
      entries?.rb_offers?.rbOffersFlag?.HideViewAllOffersWeb === true;

    // Filter out steps based on visibility conditions
    const filteredSteps = contentfulSteps.filter((step: any) => {
      // Filter out EPP step if not visible
      if (step.id === 'sidebar-equal-payment' && !isEppVisible) {
        return false;
      }

      // Filter out offer-related steps if offers are hidden
      if (
        hideOffersWeb &&
        (step.id === 'sidebar-offers' ||
          step.id === 'offers' ||
          step.id?.toLowerCase().includes('offer'))
      ) {
        return false;
      }

      return true;
    });

    // Map contentful steps to TutorialStepData format
    return filteredSteps.map((step: any) => ({
      id: step.id,
      title: step.title,
      description: step.description,
      selector: step.selector,
      image: step.image ? assets[step.image] : undefined,
    }));
  }, [
    entries?.rb_announcement?.interactiveTutorial,
    isEppVisible,
    assets,
    entries?.rb_offers?.rbOffersFlag?.HideViewAllOffersWeb,
  ]);

  // Extract button texts from Contentful
  const tutorialButtonTexts = React.useMemo(() => {
    const announcementData = entries?.rb_announcement.interactiveModal;

    if (announcementData) {
      return {
        back: announcementData.back,
        next: announcementData.next,
        continue: announcementData.continue,
        complete: announcementData.complete,
      };
    }

    // Return empty object if not found, component will use defaults
    return {};
  }, [entries?.rb_announcement.interactiveModal]);

  const tutorial = useTutorial({
    steps: tutorialSteps,
    onComplete: () => {
      console.log('Tutorial completed');
      // You can add analytics tracking or local storage to remember completion
    },
    onSkip: () => {
      console.log('Tutorial skipped');
      // You can add analytics tracking here
    },
  });

  // Debug helper - expose tutorial controls to window for testing
  useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).tutorial = tutorial;
      (window as any).testSelectors = () => {
        tutorialSteps.forEach((step, index) => {
          if (step.selector) {
            const element = document.querySelector(step.selector);
            console.log(
              `Step ${index + 1} (${step.id}):`,
              step.selector,
              element ? '✓ Found' : '✗ Not found',
              element
            );
          }
        });
      };
      const hideOffersWeb =
        entries?.rb_offers?.rbOffersFlag?.HideViewAllOffersWeb === true;
      console.log(
        `Tutorial steps updated. EPP visible: ${isEppVisible}, Offers hidden: ${hideOffersWeb}, Total steps: ${tutorialSteps.length}`
      );
    }
  }, [tutorial, tutorialSteps, isEppVisible]);
  useEffect(() => {
    if (accountId && !popupLoading && !hasPopupRequestStartedRef.current) {
      hasPopupRequestStartedRef.current = true;
      dispatch(fetchPopupStatusRequest({ accountId, customerId }));
    }
  }, [accountId, customerId, dispatch, popupLoading, popupStatus]);
  const ifHasClickedOffer = localStorage.getItem('hasClickedOffer');
  const { displayBusinessName } = useSelector(
    (state: RootState) => state.contactInfo
  );

  useEffect(() => {
    if (accountId) {
      if (
        displayBusinessName == null &&
        accountDetails?.productName === 'Rogers Small Business'
      ) {
        dispatch(displayBusinessNameRequest({ accountId }));
      }
    }
  }, [accountDetails?.productName, accountId, dispatch]);

  const suppressBusinessName = useSuppressBusinessName({
    displayBusinessName,
    entries,
    productName: accountDetails?.productName,
  });

  console.log(
    displayBusinessName,
    'displayBusinessName',
    accountDetails?.productName
  );
  useEffect(() => {
    if (accountId) {
      // Check if offers are globally disabled via contentful flag
      const rbOffersFlag = entries?.rb_offers?.rbOffersFlag;
      const allOffersDisabledWeb = rbOffersFlag?.AllOffersDisabledWeb === true;

      // Only fetch offers if they're not globally disabled for web
      if (
        !allOffersDisabledWeb &&
        ifHasClickedOffer !== 'true' &&
        offer?.offers?.length === 0
      ) {
        dispatch(fetchOfferRequest({ accountId, customerId }));
      } else {
        console.log('Offers are globally disabled for web via contentful flag');
      }
    }
  }, [
    accountId,
    customerId,
    dispatch,
    entries?.rb_offers?.rbOffersFlag,
    ifHasClickedOffer,
  ]);

  console.log('nisha', rewards);
  useEffect(() => {
    if (!contactDetails?.availableCards[0]?.preferredName) {
      dispatch(
        contactInfoRequest({
          accountId: accountId,
          primaryCustomerId: customerId,
          customerId: customerId,
        })
      );
    }
  }, [accountId, customerId, dispatch]);

  useEffect(() => {
    if (accountId && customerId) {
      dispatch(transactionRequest({ accountId, customerId, limit: 3 }));
    }
  }, [dispatch, accountId, customerId]);

  useEffect(() => {
    if (accountDetails?.customer && rewards?.rewards == null) {
      const payload = {
        accountId: accountDetails?.accountId,
        cardLastFourDigits: accountDetails?.customer?.cardLast4,
      };
      dispatch(rewardsRequest(payload));
    }
  }, [accountDetails]);

  useEffect(() => {
    if (isAuthenticated) {
      trackEvent(
        EventType.PAGE_VIEW,
        'signin',
        window.location.href,
        '',
        false,
        undefined,
        undefined,
        false,
        {},
        false,
        false,
        {},
        false,
        false,
        true
      );
    }
  }, []);

  useEffect(() => {
    const hasError = [error, transactionErr, paymentErr].some(
      (e) => e !== null && typeof e === 'string' && e.trim() !== ''
    );
    setShowApiErrorBanner(hasError);
  }, [error, transactionErr, paymentErr]);

  const { cardStructure } = useProductName();

  const handleSecondaryBtnClick = () => {
    if (supplementaryCardoffer) {
      setPreviousOffer('supplementary');
    } else if (creditLimitIncOffer) {
      setPreviousOffer('creditLimit');
    } else if (balanceTrfroffer) {
      setPreviousOffer('balanceTransfer');
    } else if (isRESIoffer) {
      setPreviousOffer('resi');
    }
    setSupplementaryCardoffer(false);
    setCreditLimitIncOffer(false);
    setBalanceTrfroffer(false);
    setRESIoffer(false);
    setShowOfferModal(true);
    setConfirmationModalOpen(true);
  };
  useEffect(() => {
    if (isReminderModalOpen) {
      setSupplementaryCardoffer(false);
      setCreditLimitIncOffer(false);
      setBalanceTrfroffer(false);
      setRESIoffer(false);

      if (supplementaryCardoffer) {
        setPreviousOffer('supplementary');
      } else if (creditLimitIncOffer) {
        setPreviousOffer('creditLimit');
      } else if (balanceTrfroffer) {
        setPreviousOffer('balanceTransfer');
      } else if (isRESIoffer) {
        setPreviousOffer('resi');
      }
    }
  }, [isReminderModalOpen]);

  const handleConfirmationOk = () => {
    // bl_submit,all_dismiss
    dispatch(
      fetchOfferPreferenceRequest({
        accountId: accountId,
        customerId: customerId,
        offerPreference:
          previousOffer === 'supplementary'
            ? 'SCO_DISMISS'
            : previousOffer === 'creditLimit'
              ? 'CLI_DISMISS'
              : previousOffer === 'balanceTransfer'
                ? 'BT_DISMISS'
                : previousOffer === 'resi' && 'RESI_DISMISS',
      })
    );
    setConfirmationModalOpen(false);
    setShouldShowModal(false);
    setShowOfferModal(false);
  };
  const handleGoBack = () => {
    setConfirmationModalOpen(false);
    setIsReminderModalOpen(false);
    if (previousOffer === 'supplementary') {
      setSupplementaryCardoffer(true);
    } else if (previousOffer === 'creditLimit') {
      setCreditLimitIncOffer(true);
    } else if (previousOffer === 'balanceTransfer') {
      setBalanceTrfroffer(true);
    } else if (previousOffer === 'resi') {
      setRESIoffer(true);
    }
    setPreviousOffer(null);
  };
  const handlePrimaryBtnClick = () => {
    if (supplementaryCardoffer || creditLimitIncOffer || isRESIoffer) {
      dispatch(
        fetchOfferPrefSubmitRequest({
          accountId: accountId,
          customerId: customerId,
          bankAccountId: accountId,
          offerStatus: 'Active',
          offerKeyValue: supplementaryCardoffer
            ? 'SCO'
            : creditLimitIncOffer
              ? 'CLI'
              : isRESIoffer
                ? 'RESI'
                : '',
          expiryDate: supplementaryCardoffer
            ? offer?.offers?.[0]?.scoResponse?.expiry_date
            : creditLimitIncOffer
              ? offer?.offers?.[0]?.cliResponse?.expiry_date
              : isRESIoffer
                ? offer?.offers?.[0]?.resiResponse.expiry_date
                : '',
        })
      );
    }
    if (balanceTrfroffer) {
      setPreviousOffer('balanceTransfer');
      setShowOfferModal(true);
    }
    setBalanceTrfroffer(false);
    setCreditLimitIncOffer(false);
    setSupplementaryCardoffer(false);

    if (supplementaryCardoffer) {
      navigate('/request-supplementary');
      setShowOfferModal(false);
    } else if (creditLimitIncOffer) {
      setShowOfferModal(false);
      const baseUrl =
        entries?.rb_links?.rbLinksCollection?.credit_limit_increase;
      const accountNumber = accountId;

      if (baseUrl && accountNumber) {
        const url = new URL(baseUrl);
        url.searchParams.append('account_number', accountNumber);
        window.open(url.toString(), '_blank');
      }
    } else if (isRESIoffer) {
      window.open(rb_offer?.webResiOffer?.url, '__blank__');
      setRESIoffer(false);
      setShowOfferModal(true);
    } else {
      setBalanceTrfroffer(false);
      setIsBTAccept(true);
    }
  };
  const handleOkBtOffer = () => {
    if (previousOffer == 'balanceTransfer') {
      dispatch(
        fetchOfferPreferenceRequest({
          accountId: accountId,
          customerId: customerId,
          offerPreference: 'BT_SUBMIT',
          endDate:
            offer?.offers?.[0]?.btoffersResponse?.availableOffers?.[0]
              ?.offerDetails?.endDate,
        })
      );
    }
    setShowOfferModal(false);
    setIsBTAccept(false);
  };
  const handlePreBanner = () => {
    localStorage.setItem('postLoginNotificationBannerVisible', 'false');
    setPostNotificationBanner(false);
  };
  useEffect(() => {
    setPostNotificationBanner(
      entries?.rb_banner?.bannerVisibility?.postLoginNotificationBanner_web
    );
    if (localStorage.getItem('postLoginNotificationBannerVisible') == 'false') {
      setPostNotificationBanner(false);
    }
  }, []);

  const handlePrimaryButton = (popupType = '') => {
    if (popupType == 'activate-card') {
      navigate('/manage-card?action=activate-card');
    }
    if (popupType == 'unlockcard') {
      navigate('/lock-unlock');
    }
    if (popupType == 'eStatementpref') {
      navigate('/my-profile');
    }
    if (popupType == 'linkcard') {
      navigate('/link-account');
    }
  };

  const handleRemindMeLater = (popupType = '') => {
    if (popupType == 'activate-card') {
      localStorage.setItem('activateCard_remindLater', 'true');
      setIsactivatePopup(false);
    }
    if (popupType == 'unlockcard') {
      localStorage.setItem('unLockCardpopup_remindLater', 'true');
      setIsUnlockCardPopup(false);
    }

    if (popupType == 'eStatementpref') {
      dispatch(
        updatePopupStatusRequest({
          accountId: accountId,
          customerId: customerId,
          status: 'STMTRMDATE',
        })
      );

      setIsEstatementPopup(false);
    }
    if (popupType == 'linkPopup') {
      dispatch(
        updatePopupStatusRequest({
          accountId: accountId,
          customerId: customerId,
          status: 'LINKDSSTATUS',
        })
      );
      setIsLinkPopup(false);
    }
    setShowOfferModal(false);
  };
  const handleDismiss = (popupType = '') => {
    if (popupType == 'eStatementpref') {
      localStorage.setItem('eStatementPref_dismiss', 'true');
      setIsEstatementPopup(false);
    }
    if (popupType == 'linkPopup') {
      localStorage.setItem('linkPopup_dismiss', 'true');
      setIsLinkPopup(false);
    }
    setShowOfferModal(false);
  };
  if (!rewards || offer?.loading || eppLoading || popupLoading) {
    return (
      <div className="flex justify-center items-center h-[80%] bg-slate-50">
        <Spinner />
      </div>
    );
  }

  const handleMaybeLaterOption = (option: string) => {
    let preference = '';
    const currentOfferType = offer?.offers?.[0]?.offerType;
    // Map option labels to the correct API values
    if (currentOfferType === 'SCO') {
      if (option === 'One week') {
        preference = 'SCO_RMLATER_WEEK';
      } else if (option === 'One month') {
        preference = 'SCO_RMLATER_MONTH';
      }
    } else if (currentOfferType === 'CLI') {
      // CLI doesn't have remind later options based on the API
      console.log('CLI offer type does not support remind later options');
      localStorage.setItem('hasDismissedOffer', 'true');

      // setMaybeLaterModalOpen(false);
      // onClose();
      return;
    } else if (currentOfferType === 'BT') {
      if (option === 'One week') {
        preference = 'BT_RMLATER_WEEK';
      } else if (option === 'One month') {
        preference = 'BT_RMLATER_MONTH';
      }
    } else if (currentOfferType === 'RESI') {
      if (option === 'One week') {
        preference = 'RESI_RMLATER_WEEK';
      } else if (option === 'One month') {
        preference = 'BT_RMLATER_MONTH';
      }
    }

    if (preference) {
      console.log('Sending offer preference:', preference);
      dispatch(
        fetchOfferPreferenceRequest({
          accountId: accountId,
          customerId: customerId,
          offerPreference: preference,
        })
      );
    }

    setIsReminderModalOpen(false);
  };
  return (
    <InteractiveTutorial
      steps={tutorialSteps}
      isActive={tutorial.isActive}
      currentStepIndex={tutorial.currentStepIndex}
      onComplete={tutorial.completeTutorial}
      onSkip={tutorial.skipTutorial}
      buttonTexts={tutorialButtonTexts}
    >
      {showFeatureFlagMessage && (
        <FeatureFlagMessage className="md:left-20 left-0" />
      )}

      {postNotificationBanner && (
        <InlineError
          bannerText={entries?.rb_banner?.webPostLoginText}
          aria-live="assertive"
          fontSize={'text-[15px]'}
          onClose={() => handlePreBanner()}
          oncloseHide={true}
          banner={true}
          error={false}
        />
      )}
      {showApiErrorBanner ? (
        <div className="w-full sm:px-4 md:px-[40px] py-[10px] bg-[#FFF6F3] flex gap-[20px] items-center top-0 left-0 md:left-20 md:w-[stretch]">
          <div className="flex items-center gap-[20px]">
            {' '}
            <div className="flex-shrink-0">
              <img
                src={assets?.infoToolTip}
                alt="infoIcon"
                className="w-6 h-6"
              />
            </div>
            <p
              className="text-[#5B1C00] text-base font-medium"
              aria-label={renderDescriptionParagraphs(
                entries?.rb_view_statements?.apiFailureBannerMsg,
                ' ',
                true
              )}
            >
              {renderDescriptionParagraphs(
                entries?.rb_view_statements?.apiFailureBannerMsg
              )}
            </p>
          </div>
          <div className="flex-grow"></div>
          <div
            aria-label={entries?.rb_view_statements?.reload}
            className="text-[#DA291C] text-base font-bold cursor-pointer"
            onClick={() => window.location.reload()}
          >
            {entries?.rb_view_statements?.reload}
          </div>
          <img
            src={assets?.closeIcon}
            alt="closeIcon"
            className="w-6 h-6 cursor-pointer"
            onClick={() => setShowApiErrorBanner(false)}
          />
        </div>
      ) : null}

      {accountDetails && isAuthenticated && (
        <div
          className="flex flex-1 p-6 bg-bg-body flex-col"
          aria-live="polite"
          style={{
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <div className="flex justify-between items-center mb-4 ml-[10px]">
            <h1
              className="text-[20px] font-[500] md:font-[600] text-[#1F1F1F] md:text-start text-center"
              aria-label={`${
                suppressBusinessName
                  ? displayBusinessName
                  : `${entries?.rb_welcome_title?.welcomeText}`
              }, ${
                contactDetails?.availableCards[0]?.preferredName
                  ? contactDetails?.availableCards[0]?.preferredName
                  : contactDetails?.availableCards[0]?.nameOnCard
              }`}
            >
              {suppressBusinessName
                ? displayBusinessName + ', '
                : `${entries?.rb_welcome_title?.welcomeText}, `}
              {contactDetails?.availableCards[0]?.preferredName
                ? contactDetails?.availableCards[0]?.preferredName
                : contactDetails?.availableCards[0]?.nameOnCard}
            </h1>
          </div>

          <div className="flex gap-4 flex-col xl:flex-row">
            <section
              aria-labelledby="master-card-section"
              className="xl:min-w-[350px]"
            >
              <h2 id="master-card-section" className="sr-only">
                Master Card Details
              </h2>
              {rewards && (
                <MasterCard
                  vertical={!cardStructure?.isHorizontal}
                  assets={assets}
                  contentfulData={entries?.rb_digital_cardview}
                  rewardsData={entries?.rb_view_account_details}
                  setShowFeatureFlagMessage={setShowFeatureFlagMessage}
                  featureFlaggingData={
                    entries?.rb_feature_flagging?.featureFlagging?.dashboard
                      ?.rewards
                  }
                  isLoading
                />
              )}
            </section>
            <div className="lg:col-span-2 lg:flex flex-col gap-[17px] xl:w-[calc(100vw-545px)]">
              {entries?.rb_feature_flagging?.featureFlagging?.dashboard
                ?.view_all_announcements && (
                <section
                  aria-labelledby="announcements-section"
                  className="bg-white  rounded-[15px] sm:shadow-md md:shadow-none"
                >
                  <h2 id="announcements-section" className="sr-only">
                    Announcements
                  </h2>
                  <Announcements
                    assets={assets}
                    contentfulData={entries?.rb_announcement}
                    setShowFeatureFlagMessage={setShowFeatureFlagMessage}
                    featureFlaggingData={
                      entries?.rb_feature_flagging?.featureFlagging?.dashboard
                        ?.view_all_announcements
                    }
                    onStartTutorial={tutorial.startTutorial}
                  />
                </section>
              )}

              <section
                aria-labelledby="payment-due-section"
                className="bg-white p-5 lg:max-h-[201px] lg:h-[201px] md:h-auto rounded-[15px] sm:shadow-md  md:shadow-none mt-2"
              >
                <h2 id="payment-due-section" className="sr-only">
                  Payment Due Details
                </h2>

                <PaymentDue
                  userData={accountDetails}
                  contentfulData={entries?.rb_view_statements}
                  isLoading
                />
              </section>

              <section
                aria-labelledby="recent-transactions-section"
                className="bg-white p-5 rounded-[15px] lg:shadow-recent-transactions md:shadow-none sm:shadow-none lg:h-[285px] lg:max-h-[285px] lg:pt-0 mt-[10px] flex flex-col overflow-hidden"
              >
                <h2
                  id="recent-transactions-section"
                  className="sr-only mb-[20px]"
                >
                  Recent Transactions
                </h2>

                <RecentTransaction
                  transactionDetails={transactions}
                  assets={assets}
                  contentfulData={entries?.rb_recent_transactions}
                />
              </section>
            </div>
          </div>

          {/*
      //dashboard popup */}

          <CommanModal
            isOpen={
              (isActivatePopup ||
                isEstatementPopup ||
                isUnlockCardPopup ||
                isLinkPopup) &&
              !anyofferVisible
            }
            onClose={() =>
              handlePrimaryButton(
                isActivatePopup
                  ? 'activate-card'
                  : isEstatementPopup
                    ? 'eStatementpref'
                    : isUnlockCardPopup
                      ? 'unlockcard'
                      : isLinkPopup
                        ? 'linkcard'
                        : ''
              )
            }
            onExtraButtonClick={() =>
              isActivatePopup
                ? handleRemindMeLater(isActivatePopup ? 'activate-card' : '')
                : isEstatementPopup
                  ? handleDismiss('eStatementpref')
                  : isUnlockCardPopup
                    ? handleRemindMeLater(isUnlockCardPopup ? 'unlockcard' : '')
                    : isLinkPopup
                      ? handleDismiss('linkPopup')
                      : null
            }
            onThirdButtonClick={() =>
              handleRemindMeLater(
                isEstatementPopup
                  ? 'eStatementpref'
                  : isLinkPopup
                    ? 'linkPopup'
                    : ''
              )
            }
            cardStatus={true}
            jsxContent={
              <div className="text-center flex flex-col justify-center items-center">
                {isLinkPopup && (
                  <div className=" border-[2px]  border-primary-red w-[50px] h-[50px] rounded-full flex items-center justify-center mb-2">
                    <img
                      src={assets?.link_rogers_popup_icon}
                      alt={
                        entries?.rb_popup?.dashboardPopup?.yourMissingOut
                          ?.title || 'Icon'
                      }
                      className="w-[30px] h-[24px] object-contain"
                    />
                  </div>
                )}

                <div
                  className="mb-4 text-[#1F1F1F] text-[22px] font-medium"
                  aria-label={
                    isActivatePopup
                      ? entries?.rb_popup?.dashboardPopup?.activateCard?.title
                      : isEstatementPopup
                        ? entries?.rb_popup?.dashboardPopup?.statementPref
                            ?.title
                        : isUnlockCardPopup
                          ? entries?.rb_popup?.dashboardPopup?.yourCardIsLocked
                              ?.title
                          : isLinkPopup
                            ? entries?.rb_popup?.dashboardPopup?.yourMissingOut
                                ?.title
                            : undefined
                  }
                >
                  {isActivatePopup &&
                    entries?.rb_popup?.dashboardPopup?.activateCard?.title}
                  {isEstatementPopup &&
                    entries?.rb_popup?.dashboardPopup?.statementPref?.title}
                  {isUnlockCardPopup &&
                    entries?.rb_popup?.dashboardPopup?.yourCardIsLocked?.title}
                  {isLinkPopup &&
                    entries?.rb_popup?.dashboardPopup?.yourMissingOut?.title}
                </div>
                <p className="mb-[40px]">
                  {isActivatePopup &&
                    entries?.rb_popup?.dashboardPopup?.activateCard
                      ?.description}
                  {isEstatementPopup &&
                    (() => {
                      const description: string =
                        entries?.rb_popup?.dashboardPopup?.statementPref
                          ?.description || '';
                      const lines: string[] = description
                        .split('\n')
                        .map((line: string) => line.trim())
                        .filter(Boolean);

                      const heading: string = lines[0];
                      const bulletPoints: string[] = lines
                        .slice(1)
                        .filter((line: string) => line.includes('•'));

                      return (
                        <div>
                          <h1
                            className="text-[14px] font-[400] mb-2 text-black"
                            aria-label={heading}
                          >
                            {heading}
                          </h1>
                          <ul className="list-disc list-inside text-left ml-[20px]">
                            {bulletPoints.map((line: string, index: number) => (
                              <li
                                key={index}
                                className="text-[14px] font-[400] text-black "
                              >
                                {line.replace('•', '').trim()}
                              </li>
                            ))}
                          </ul>
                        </div>
                      );
                    })()}
                  {isUnlockCardPopup &&
                    entries?.rb_popup?.dashboardPopup?.yourCardIsLocked
                      ?.description}
                  {isLinkPopup &&
                    entries?.rb_popup.dashboardPopup.yourMissingOut?.description?.replace(
                      '<name>',
                      accountDetails?.customer?.firstName +
                        ' ' +
                        accountDetails?.customer?.lastName
                    )}
                </p>
              </div>
            }
            buttonText={
              isActivatePopup
                ? entries?.rb_popup?.dashboardPopup?.activateCard?.primaryBtn
                : isEstatementPopup
                  ? entries?.rb_popup?.dashboardPopup?.statementPref?.primaryBtn
                  : isUnlockCardPopup
                    ? entries?.rb_popup?.dashboardPopup?.yourCardIsLocked
                        ?.primaryBtn
                    : isLinkPopup
                      ? entries?.rb_popup.dashboardPopup.yourMissingOut
                          ?.primaryBtn
                      : ''
            }
            extraButtonText={
              isActivatePopup
                ? entries?.rb_popup?.dashboardPopup?.activateCard?.thirdBtn
                : isEstatementPopup
                  ? entries?.rb_popup?.dashboardPopup?.statementPref?.secondBtn
                  : isUnlockCardPopup
                    ? entries?.rb_popup?.dashboardPopup?.yourCardIsLocked
                        ?.thirdBtn
                    : isLinkPopup
                      ? entries?.rb_popup?.dashboardPopup?.statementPref
                          ?.secondBtn
                      : null
            }
            closeIcon={false}
            dasboardPopup={true}
            thirdButtonText={
              isEstatementPopup
                ? entries?.rb_popup?.dashboardPopup?.statementPref?.thirdBtn
                : isLinkPopup
                  ? entries?.rb_popup.dashboardPopup.yourMissingOut?.thirdBtn
                  : null
            }
            buttonClassName={isLinkPopup ? 'flex-col' : 'flex-col mt-10'}
          />

          {/* //Offers popup */}
          {ifHasClickedOffer !== 'true' &&
            showOfferModal &&
            shouldShowModal &&
            (supplementaryCardoffer ||
              creditLimitIncOffer ||
              balanceTrfroffer ||
              isRESIoffer) &&
            rb_offer &&
            offer?.offers?.[0] &&
            entries?.rb_offers?.rbOffersFlag?.AllOffersDisabledWeb !== true && (
              <OfferModal
                isOpen={
                  (supplementaryCardoffer ||
                    creditLimitIncOffer ||
                    balanceTrfroffer ||
                    isRESIoffer) &&
                  showOfferModal
                }
                onClose={() =>
                  supplementaryCardoffer
                    ? setSupplementaryCardoffer(false)
                    : creditLimitIncOffer
                      ? setCreditLimitIncOffer(false)
                      : balanceTrfroffer
                        ? setBalanceTrfroffer(false)
                        : isRESIoffer && setRESIoffer(false)
                }
                img={
                  supplementaryCardoffer
                    ? assets['requestCardImg']
                    : creditLimitIncOffer
                      ? assets['creditLimitImg']
                      : balanceTrfroffer
                        ? assets['balanceTransferImg']
                        : isRESIoffer && assets['webResiOfferImg']
                }
                jsxElement={
                  supplementaryCardoffer ? (
                    <SupplementaryCardOfferContent rb_offer={rb_offer} />
                  ) : creditLimitIncOffer ? (
                    <CardLimitIncOfferContent
                      rb_offer={rb_offer}
                      offer={offer?.offers?.[0]}
                    />
                  ) : balanceTrfroffer ? (
                    <BalanceTrfrOfferContent
                      rb_offer={rb_offer}
                      offerDetails={
                        offer?.offers?.[0]?.btoffersResponse
                          ?.availableOffers?.[0]?.offerDetails?.description
                      }
                      apiOffer={
                        offer?.offers?.[0]?.btoffersResponse
                          ?.availableOffers?.[0]
                      }
                    />
                  ) : (
                    isRESIoffer && <ResiOfferContent rb_offer={rb_offer} />
                  )
                }
                primaryButtonText={
                  supplementaryCardoffer
                    ? rb_offer?.requestCard?.primary_btn_text
                    : isRESIoffer
                      ? rb_offer?.webResiOffer?.primary_btn_text
                      : rb_offer?.ctaTexts?.acceptOffer
                }
                secondaryButtonText={rb_offer?.requestCard?.secondary_btn_text}
                LegalDesc={
                  supplementaryCardoffer ? (
                    rb_offer?.requestCard?.disclaimer
                  ) : isRESIoffer ? (
                    <RegiLegalSection rb_offer={rb_offer} />
                  ) : creditLimitIncOffer ? (
                    <CreditLimitLegalSection rb_offer={rb_offer} />
                  ) : balanceTrfroffer ? (
                    <div className="text-xs text-gray-600 space-y-3 leading-relaxed">
                      {rb_offer?.balanceTransfer?.disclaimer && (
                        <p>{rb_offer.balanceTransfer.disclaimer}</p>
                      )}

                      {/* Balance Transfer Terms and Conditions Link */}
                      {rb_offer?.balanceTransfer?.TncClickableLink && (
                        <div className="mt-3 pt-2 border-t border-gray-200">
                          <a
                            href={rb_offer.balanceTransfer.TncClickableLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#4A90E2] text-xs hover:text-[#357ABD] underline cursor-pointer inline-flex items-center"
                          >
                            {rb_offer.balanceTransfer.TncClickableLink}
                          </a>
                        </div>
                      )}
                    </div>
                  ) : null
                }
                onSecondaryBtnClick={handleSecondaryBtnClick}
                onPrimaryBtnClick={handlePrimaryBtnClick}
                creditLimitIncOffer={creditLimitIncOffer}
                balanceTransfer={balanceTrfroffer}
                offerType={
                  supplementaryCardoffer
                    ? 'supplementary'
                    : creditLimitIncOffer
                      ? 'creditLimit'
                      : balanceTrfroffer
                        ? 'balanceTransfer'
                        : isRESIoffer
                          ? 'resi'
                          : undefined
                }
                isReminderModalOpen={isReminderModalOpen}
                setIsReminderModalOpen={setIsReminderModalOpen}
              />
            )}

          <CommanModal
            isOpen={confirmatioModalOpen}
            onClose={handleConfirmationOk}
            onExtraButtonClick={handleGoBack}
            cardStatus={true}
            jsxContent={
              <div className="text-center">
                <div
                  className="mb-4 text-[#1F1F1F] text-[22px] font-medium"
                  aria-label={rb_offer?.notInterestedModal?.title}
                >
                  {rb_offer?.notInterestedModal?.title}
                </div>
                <p
                  className="mb-[40px]"
                  aria-label={
                    previousOffer === 'supplementary'
                      ? rb_offer?.notInterestedModal?.descRequestCard
                      : previousOffer === 'balanceTransfer'
                        ? rb_offer?.notInterestedModal?.descBTOffer
                        : rb_offer?.notInterestedModal?.description
                  }
                >
                  {previousOffer === 'supplementary'
                    ? rb_offer?.notInterestedModal?.descRequestCard
                    : previousOffer === 'balanceTransfer'
                      ? rb_offer?.notInterestedModal?.descBTOffer
                      : rb_offer?.notInterestedModal?.description}
                </p>
              </div>
            }
            buttonText={
              previousOffer === 'balanceTransfer'
                ? rb_offer?.ctaTexts?.dismissOfferCta
                : rb_offer?.ctaTexts?.ok
            }
            extraButtonText={rb_offer?.ctaTexts?.goBack}
            closeIcon={false}
          />
          <CommanModal
            isOpen={isReminderModalOpen}
            onClose={() => handleMaybeLaterOption('One week')}
            onExtraButtonClick={() => handleMaybeLaterOption('One month')}
            onThirdButtonClick={handleGoBack}
            cardStatus={true}
            jsxContent={
              <div className="text-center">
                <div
                  className="mb-4 text-[#1F1F1F] text-[22px] font-medium"
                  aria-label={rb_offer?.notInterestedModal?.title}
                >
                  {rb_offer?.notInterestedModal?.title}
                </div>
                <p className="mb-[40px]">
                  {rb_offer?.notInterestedModal?.description}
                </p>
              </div>
            }
            buttonText={'One Week'}
            extraButtonText={'One Month'}
            thirdButtonText={rb_offer?.ctaTexts?.goBack}
            closeIcon={false}
            buttonstyle={'primary'}
            extrabuttonstyle={'primary'}
            thirdbuttonstyle={'secondary'}
          />
          {isBtAccept && (
            <SuccessModel
              isOpen={isBtAccept}
              title={rb_offer?.balanceTransfer?.accept}
              subTitle={rb_offer?.balanceTransfer?.call}
              successIcon={false}
              closeModal={handleOkBtOffer}
              errorIcon={false}
              buttonText={rb_offer?.ctaTexts?.closeCta}
            />
          )}
        </div>
      )}
    </InteractiveTutorial>
  );
};

export default Home;
